import * as React from "react"
import { Badge, Box } from "@mui/material"

import { NotAllowedBlock } from "@components"
import { EditButton, SkipButton } from "./actions"

const stylesBox = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	gap: 1
}


export default function mappedColumn(isSkuMappingTable = false) {
	return [{
		name: 'isMapped', label: 'Is Mapped?',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: 'isMapped', label: 'Mapped Status',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'normal', minWidth: 180 }
			}),
			customBodyRowRender: (value, rowData) => {
				return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
					<Badge color={value ? 'success' : 'error'} badgeContent=" "  sx={{ mb: 2 }}/>
					{!!rowData.skuName && rowData.skuName != 'Unknown' && <span>{rowData.skuName}</span>}
					{(!rowData.skuName || rowData.skuName === 'Unknown') && <NotAllowedBlock/>}
					<Box sx={stylesBox}>
						<EditButton rowData={rowData} isSkuMappingTable={isSkuMappingTable}/>
						<SkipButton rowData={rowData} isSkuMappingTable={isSkuMappingTable} />
					</Box>
				</Box>
			}
		}
	}]
}